module.exports = __webpack_public_path__ + "img/AudreyBodman.4df76619.jpg";